export default __webpack_public_path__ + "static/media/2037.b1076b86.png";